import React, { useEffect, useState } from 'react'
import ProductTabTable from './productTabTable'
import ProductDrawer from './productDrawer'
import ProductSrc from '../../productSrc'
import { message } from 'antd'
import Utils from '../../../../utils/Utils'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import productSrc from '../../productSrc'

function ProductTab(props) {
  const [visible, setVisible] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [editDataDrawer, setEditDataDrawer] = useState(null)
  const [loading, setLoading] = useState(false)
  const [products, setProducts] = useState([])
  const [existMoreInfo, setExistMoreInfo] = useState(false)
  const [nextPage, setNextPage] = useState('')

  useEffect(() => {
    if (props.keyTab === '1') {
      loadData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.keyTab])

  function loadData() {
    setLoading(true)
    ProductSrc.getProducts('', 5, true, 'desc')
      .then(products => {
        setProducts(getProduct(products))
        setNextPage(products.data.next_page_url)
        setExistMoreInfo(products.data.next_page_url !== null)
        setLoading(false)
      })
      .catch(err => {
        setLoading(false)
        console.log(err)
      })
  }

  const moreInfo = () => {
    if (existMoreInfo) {
      setLoading(true)
      Utils.getNextPage(nextPage)
        .then(response => {
          setProducts(products.concat(getProduct(response)))
          setNextPage(response.data.next_page_url)
          setExistMoreInfo(response.data.next_page_url !== null)
          setLoading(false)
        })
        .catch(err => {
          console.log(err)
          message.error('No se ha podido cargar la información')
        })
    }
  }

  const getProduct = products => {
    if (products !== 'Too Many Attempts.') {
      console.log('data ', products.data.data);
      
      let _products = products.data.data || []
      return _products.map((d, i) => ({
        key: d.id,
        _id: d.id,
        company_id: d.company_id,
        productDescription: d.description,
        product_category_id: d.product_category_id,
        product_subcategory_id: d.product_subcategory_id,
        product_department: d.product_category.product_department,
        suggested_price: d.suggested_price,
        uom_id: d?.uom_id ? d.uom_id : null,
        brand_id: d.brand?.id ? d.brand_id : null,
        brand_name: d.brand?.name ? d.brand.name : null,
        all_countries_id: d.countries.length > 0 ? d.countries.map(c => (c.id !== null ? c.id : null)) : [],
        all_countries: d.countries.length > 0 ? d.countries.map(c => (c.name !== null ? c.name : '')).join(', ') : 0,
        all_chains_id: d.store_chains.length > 0 ? d.store_chains.map(c => (c.id !== null ? c.id : null)) : [],
        all_chains: d.store_chains.length > 0 ? d.store_chains.map(c => (c.name !== null ? c.name : '')).join(', ') : 0,
        minimal_expresion: d.minimal_expresion,
        is_inventoriable: d.is_inventoriable,
        is_taxable: d.is_taxable,
        product_category: d.product_category,
        product_subcategory: d.product_subcategory,
        company_name: d.company?.name ? d.company?.name : 'Señor tendero',
        pap1_id: d.product_active_principle1?.id ? d.product_active_principle_1 : null,
        pap2_id: d.product_active_principle2?.id ? d.product_active_principle_2 : null,
        pap3_id: d.product_active_principle3?.id ? d.product_active_principle_3 : null,
        product_active_principle_1: d.product_active_principle1 ? (d.product_active_principle1.name ? d.product_active_principle1.name : 'N/A') : 'N/A',
        product_active_principle_2: d.product_active_principle2 ? (d.product_active_principle2.name ? d.product_active_principle2.name : 'N/A') : 'N/A',
        product_active_principle_3: d.product_active_principle3 ? (d.product_active_principle3.name ? d.product_active_principle3.name : 'N/A') : 'N/A',
        referencia_cabys: d.referencia_cabys ?? '',
        tax_product: d.tax?.id ?? null,
        tax_display_name: d.tax ? `${d.tax.country.name} - ${d.tax.isv_percentage}%` : null
      }))
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  const showDrawer = () => {
    setVisible(true)
    setEditMode(false)
  }

  const onClose = () => {
    setVisible(false)
  }

  const EditRow = data => {
    setEditDataDrawer(data)
    setVisible(true)
    setEditMode(true)
  }

  const DeleteRow = data => {
    setLoading(true)
    ProductSrc.removeProduct(data._id)
      .then(res => {
        if (res.message.length > 0) {
          message.error(res.message)
          setLoading(false)
        } else {
          message.success('Producto Eliminando')
          loadData()
        }
      })
      .catch(e => {
        message.error('Error')
        setLoading(false)
      })
  }
  const searchText = data => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(data)
    productSrc.getProducts(data, 5, excludeChars).then(response => {
      setProducts(getProduct(response))
      setNextPage(response.data.next_page_url)
      setExistMoreInfo(response.data.next_page_url !== null)
      setLoading(false)
    })
  }

  const onSaveButton = data => {
    console.log('productos ', data);
    
    ProductSrc.saveProduct(data)
      .then(res => {
        if (res.errors && Object.keys(res.errors)?.length > 0) {
          checkErrors(res)
        } else {
          message.success('Producto Guardado')
          setVisible(false)
          loadData()
        }
      })
      .catch(e => {
        console.log(e)
        message.error('Error al guardar el producto')
        setLoading(false)
      })
  }

  const onEditButton = (data, id) => {
    ProductSrc.updateProduct(data, id)
      .then(res => {
        if (res.errors && Object.keys(res.errors)?.length > 0) {
          checkErrors(res)
        } else {
          message.success('Producto Actualizado')
          setVisible(false)
          loadData()
        }
      })
      .catch(e => {
        setLoading(false)
        console.log(e)
      })
  }

  const checkErrors = res => {
    Object.keys(res.errors).forEach(key => {
      switch (key) {
        case 'description':
          message.error(res.errors[key][0].replace('description', 'Descripción'))
          break
        case 'presentation_description':
          message.error(res.errors[key][0].replace('presentation description', 'Descripción'))
          break
        case 'suggested_price':
          message.error(res.errors[key][0].replace('suggested price', 'Precio sugerido'))
          break
        default:
          message.error(res.errors[key])
          break
      }
    })
  }

  return (
    <>
      <ProductTabTable
        handlerShowDrawer={showDrawer}
        dataSource={products}
        handlerEditRow={EditRow}
        loading={loading}
        handlerTextSearch={searchText}
        handlerDeleteRow={DeleteRow}
      />
      <LoadMoreButton handlerButton={moreInfo} moreInfo={existMoreInfo} />
      <ProductDrawer
        closable={onClose}
        visible={visible}
        cancelButton={onClose}
        saveButton={onSaveButton}
        editButton={onEditButton}
        edit={editMode}
        editData={editDataDrawer}
      />
    </>
  )
}
export default ProductTab
